export const messages = {
  description_too_long: 'Must be less than 250 characters',
  displayName_too_long: 'Must be less than 40 characters',
  displayName_too_short: 'Must be at least 2 characters',
  invalid_firebase_ref: 'Must be at least 6 characters',
  password_too_short: 'Must be at least 4 characters',
  teacher_exists: 'Already a teacher in this class',
  student_exists: 'Already a student in this class',
  'must be an enum value': 'Not an approved value',
  invalid_credentials: 'Incorrect password',
  invalid_username: 'Invalid username',
  missing_required_field: 'Required',
  username_taken: 'Username taken',
  invalid_url: 'Invalid URL'
}

export const errorToMessage = (msg, overwrite) => {
  return overwrite || messages[msg] || msg
}
